export enum PermissionType {
  ViewOnly = 0,
  AllAccess = 1,
  Hide = 2,
}
